export enum FormV2ElementTypeEnum {
  Header,
  TextBlock,
  ProfileIndividual,
  ProfileOrganization,
  PurchaseItem,
  CustomField,
  AffiliationCode,
  Listings,
  MembershipLevel,
  SocialMedia,
  FileUpload,
  OpenField,
  EmailOptIn,
}
